module.exports = __webpack_public_path__ + "img/star.858e2b73.svg";